<template>
  <section>
    <HomeButton />
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>Your Cart</h1>
          <!-- cart disini -->
          <Loading v-if="loading" />
          <CartItem
            v-for="cart in carts"
            :key="cart.id"
            :cart="cart"
          />
          <div class="empty-cart" v-if="carts.length < 1">
            <h2>-- your cart still empty --</h2>
            <button class="btn btn-outline-secondary" @click="goToHome()">Continue Shopping</button>
          </div>
        </div>
        <div class="col">
          <div class="total total-box">
            <h2>Summary:</h2><hr/>
            <div class="text-left">
              <h4>Total Items : {{currFormat(totalItems)}}</h4>
              <h4>Total Price : {{currFormat(totalPrice)}}</h4>
            </div>
            <div class="error-box">
              <p><span class="error" v-html="reason" /></p>
            </div>
            <div>
              <button @click="checkout()" class="btn btn-checkout btn-info" :disabled="!canCheckout">Checkout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CartItem from '@/components/CartItem'
import HomeButton from '@/components/HomeButton'
import Loading from '@/components/Loading.vue'
import { mapState } from 'vuex'

export default {
  components: {
    CartItem,
    HomeButton,
    Loading
  },
  data () {
    return {
      totalItems: 0,
      totalPrice: 0,
      canCheckout: false,
      reason: ''
    }
  },
  methods: {
    currFormat (currency) {
      return currency.toLocaleString()
    },
    goToHome () {
      this.$router.push('/')
    },
    checkout () {
      this.$store.dispatch('checkout')
    }
  },
  created () {
    this.$store.dispatch('fetchCart')
  },
  computed: {
    ...mapState(
      [
        'carts',
        'loading'
      ]
    )
  },
  watch: {
    carts () {
      if (this.carts.length > 0) this.canCheckout = true
      this.totalItems = 0
      this.totalPrice = 0
      const temp = []
      this.carts.forEach(element => {
        this.totalItems = this.totalItems + element.quantity
        this.totalPrice = this.totalPrice + (element.quantity * element.Product.price)
        if (element.Product.stock < 1) {
          this.canCheckout = false
          temp.push(`"${element.Product.name}" is outstock`)
        }
        if (element.quantity > element.Product.stock) {
          this.canCheckout = false
          temp.push(`"${element.Product.name}" quantity not match with stock`)
        }
      })
      this.reason = temp.join('<br>')
    },
    totalItems () {
      if (this.totalItems > 0 && this.canCheckout === true) {
        this.canCheckout = true
      } else {
        this.canCheckout = false
      }
    }
  }
}
</script>

<style scoped>
  input {
    text-align: center;
    display: inline;
    width: 50px;
    outline: 0;
    border-width: 0 0 2px;
    border-color: green
  }
  .btn-checkout {
    margin-top: 5px
  }
  .total {
    margin: auto;
    width: 80%;
    padding: 10px;
    box-shadow: 0 0 2px 1px #1e524b;
  }
  .empty-cart {
    margin-top: 80px;
    color: gray;
    margin-bottom: 200px;
  }
  .error {
    color: red;
    font-size: 12px;
  }
  .error-box p {
    margin: 0px;
    padding: 0px;
  }
  .total-box {
    position: fixed;
    width: 450px;
    left: 58%;
    top: 128px;
  }
</style>
